
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.94.32a.582.582 0 00-.52-.32H.58a.58.58 0 00-.52.32.564.564 0 00.062.602L5.036 7.14v4.475c0 .213.176.385.392.385h1.144a.388.388 0 00.391-.385V7.14L11.878.922A.563.563 0 0011.94.32zM9.956 1.494l-3.78 4.783a.223.223 0 01-.35 0l-3.78-4.783a.217.217 0 01.175-.351h7.56c.184 0 .288.208.175.351z","fill":"#fff"}})])
          )
        }
      }
    